import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SigncoFormGroup } from "@ramudden/models/form";
import { DomainDataService } from "../../../services/domain-data.service";
import { TranslateEnumPipe } from "../../pipes/translate-enum.pipe";
import { FormValidationComponent } from "../form-validation/form-validation.component";

@Component({
    selector: "app-model-translation-form",
    templateUrl: "./model-translation-form.component.html",
    imports: [FormValidationComponent, ReactiveFormsModule, TranslateModule, TranslateEnumPipe, NgClass],
})
export class ModelTranslationFormComponent {
    @Input() parentFormGroup: SigncoFormGroup;
    @Input() formGroupName: string;
    @Input() controlLabel: string;
    @Input() autofocus = false;
    @Input() multiline = false;

    languages: string[];

    constructor(private readonly domainDataService: DomainDataService) {
        this.languages = this.domainDataService.getLanguages();
    }
}
